import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics/track';

/**
 * PageViewTracker Component
 *
 * Fires trackPageView() on every route change. The useRef guard (not just
 * the effect's dependency array) prevents double-counting the same
 * pathname — React Strict Mode invokes effects twice on mount in dev, and
 * without this guard every reload would count +2.
 *
 * Usage: Place inside <BrowserRouter> but outside <Routes>, next to
 * ScrollToTop.
 */
export function PageViewTracker() {
  const { pathname } = useLocation();
  const lastTracked = useRef<string | null>(null);

  useEffect(() => {
    if (lastTracked.current === pathname) return;
    lastTracked.current = pathname;
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
